import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { ClickOutsideModule } from '@epicuro-next/ataraxia/click-outside';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { SITE_SELECTOR_NAMESPACE } from '@epicuro-next/constants/rule-engine/site-selector-rules';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { EnvironmentModule } from '@epicuro-next/platform/environment';

import { BrandOrgSiteComponent } from './components/brand-org-site/brand-org-site.component';
import { BrandOrgSubSitesComponent } from './components/brand-org-sub-sites/brand-org-sub-sites.component';
import { BrandOrgTextOrLogoComponent } from './components/brand-org-text-or-logo/brand-org-text-or-logo.component';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    ImageModule,
    IconsModule,
    OverlayModule,
    AccordionModule,
    ClickOutsideModule,
    EnvironmentModule,
    RouterModule,
    ConfigurationModule.forFeature(SITE_SELECTOR_NAMESPACE),
  ],
  declarations: [
    BrandOrgSiteComponent,
    BrandOrgSubSitesComponent,
    BrandOrgTextOrLogoComponent,
  ],
  exports: [BrandOrgSiteComponent],
})
export class SiteSelectorModule {}
